
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { UsuarioComponent } from './usuario/usuario.component';
import {NavbarComponent} from "./navbar/navbar.component";
import {RoutingModule} from "./navbar/routing.module";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpModule } from '@angular/http';
import {
  DataTableModule, SharedModule,
  FieldsetModule, InputTextModule,
  CalendarModule, PasswordModule, DropdownModule, GrowlModule, MessagesModule,
  MenubarModule, AccordionModule, PanelModule, DialogModule, TabViewModule, PickListModule, ConfirmationService,
  ConfirmDialogModule, ChartModule, SpinnerModule, TooltipModule, InputTextareaModule, ToggleButtonModule
} from 'primeng/primeng';
import { ProductoComponent } from './producto/producto.component';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { LoadingComponent } from './loading/loading.component';
import {ProductoService} from "./Services/producto.service";
import { CategoriaComponent } from './categoria/categoria.component';
import { TiendaComponent } from './tienda/tienda.component';
import { ProvedorComponent } from './provedor/provedor.component';
import { EmpleadoComponent } from './empleado/empleado.component';
import { HistorialComponent } from './historial/historial.component';
import { ListaPrecioComponent } from './lista-precio/lista-precio.component';
import { TrasladoComponent } from './traslado/traslado.component';
import { GastoComponent } from './gasto/gasto.component';
import { OrdenCompraComponent } from './orden-compra/orden-compra.component';
import {CategoriaService} from "./Services/categoria.service";
import {EmpleadoService} from "./Services/empleado.service";
import {GastoService} from "./Services/gasto.service";
import {HistorialService} from "./Services/historial.service";
import {ListaPrecioService} from "./Services/listaPrecio.service";
import {OrdenCompraService} from "./Services/ordenCompra.service";
import {ProvedorService} from "./Services/provedor.service";
import {TiendaService} from "./Services/tienda.service";
import {TrasladoService} from "./Services/traslado.service";
import {UsuarioService} from "./Services/usuario.service";
import { InventarioComponent } from './inventario/inventario.component';
import {InventarioService} from "./Services/inventario.service";
import { InicioComponent } from './inicio/inicio.component';
import { POSComponent } from './pos/pos.component';
import {PosService} from "./Services/pos.service";
import {LoginComponent} from "./Login/login.component";
import {AuthenticationService} from "./Login/authentication.service";
import { ClienteComponent } from './cliente/cliente.component';
import { SeparadoComponent } from './separado/separado.component';
import { ComboComponent } from './combo/combo.component';
import {ClienteService} from "./Services/clientes.service";
import { PagosSeparadosComponent } from './pagos-separados/pagos-separados.component';
import {ComboService} from "./Services/combo.service";
import {SeparadoService} from "./Services/separado.service";
import {AuthGuard} from "./Login/auth.guard";
import { CabeceraComponent } from './cabecera/cabecera.component';
import { ConfiguracionComponent } from './configuracion/configuracion.component';

import {CurrencyMaskModule} from "ng2-currency-mask";
import {ConfiguracionService} from "./Services/configuracion.service";
import { ListaFacturasComponent } from './lista-facturas/lista-facturas.component';
import {FacturaService} from "./Services/factura.service";
import { ReportesComponent } from './reportes/reportes.component';
import {UrlService} from "./Services/url.service";

@NgModule({
  declarations: [
    AppComponent,
    UsuarioComponent,
    NavbarComponent,
    ProductoComponent,
    LoadingComponent,
    CategoriaComponent,
    TiendaComponent,
    ProvedorComponent,
    EmpleadoComponent,
    HistorialComponent,
    ListaPrecioComponent,
    TrasladoComponent,
    GastoComponent,
    OrdenCompraComponent,
    InventarioComponent,
    InicioComponent,
    POSComponent,
    LoginComponent,
    ClienteComponent,
    SeparadoComponent,
    ComboComponent,
    PagosSeparadosComponent,
    CabeceraComponent,
    ConfiguracionComponent,
    ListaFacturasComponent,
    ReportesComponent,
  ],
  imports: [
    CurrencyMaskModule,
    BrowserModule,
    RoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    DataTableModule,
    SharedModule,
    FieldsetModule,
    BrowserAnimationsModule,
    InputTextModule,
    CalendarModule,PasswordModule,
    DropdownModule,GrowlModule,
    MessagesModule,MenubarModule,
    AccordionModule,PanelModule,
    DialogModule,TabViewModule,
    PickListModule,ConfirmDialogModule,
    ChartModule,
    SpinnerModule,
    TooltipModule,
    InputTextareaModule,
    ToggleButtonModule


  ],
  providers: [
    ProductoService,
    CategoriaService,
    EmpleadoService,
    GastoService,
    HistorialService,
    ListaPrecioService,
    OrdenCompraService,
    ProvedorService,
    TiendaService,
    TrasladoService,
    UsuarioService,
    InventarioService,
    ConfirmationService,
    PosService,
    AuthenticationService,
    ClienteService,
    ComboService,
    SeparadoService,
    AuthGuard,
    ConfiguracionService,
    FacturaService,
    UrlService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/app.module.ts